import { useState } from "react";

import { useRouter } from "next/router";

import { Button } from "antd";
import useTranslation from "next-translate/useTranslation";
import SweetAlert from "react-bootstrap-sweetalert";

import StaticIntlTranslator from "shared/components/atoms/StaticIntlTranslator";
import api from "shared/infra/services/api";
import { clearCourseCache } from "shared/utils/clearCourseCache";
import { useAuthContext } from "shared/utils/hooks/useAuthContext";
import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";

import { EntityProps } from "../../@types/enrollments";
import handleToEnrollmentContent from "../../utils/handleToEnrollmentContent";

const ItemsToStartEnrollment = ({
  entity,
  context,
}: ItemsToStartEnrollmentProps) => {
  const router = useRouter();
  const { t } = useTranslation();
  const { loggedUser } = useAuthContext();

  const [enrollmentSuccessAlert, setEnrollmentSuccessAlert] = useState(false);
  const { setState } = useGlobalContext();

  const handleConfirm = () => {
    if (context && entity) {
      handleToEnrollmentContent({ context, entity, router });
    }

    setEnrollmentSuccessAlert(false);
  };

  const startEnrollmentRequest = async ({ context, entity }) => {
    try {
      const response = await api.post(`enrollment/start/${entity.id}`, {
        type: context,
      });

      return response.status;
    } catch (error) {
      console.log("error -->", error);
    }
    return null;
  };

  const handleEnrollment = async () => {
    if (!loggedUser) {
      setState((prev) => ({
        ...prev,
        modal: {
          open: true,
          page: "login",
        },
      }));
      return;
    }

    if (router.query.course_slug)
      clearCourseCache(router.query.course_slug as string);

    if (context === "product_bundle") setTimeout(() => router.reload(), 2000);

    try {
      await startEnrollmentRequest({ context, entity });
      setEnrollmentSuccessAlert(true);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="text-plus-btn-container">
        <Button
          block
          type="primary"
          className="buy-btn"
          onClick={() => handleEnrollment()}
        >
          <StaticIntlTranslator id="common:accessTheContent" />
        </Button>
      </div>

      <SweetAlert
        success
        title={t("common:completeRegistration")}
        style={{ borderRadius: 12 }}
        show={enrollmentSuccessAlert}
        confirmBtnText={
          context === "product_bundle"
            ? t("common:backTo")
            : t("common:accessTheContent")
        }
        onCancel={() => setEnrollmentSuccessAlert(false)}
        onConfirm={handleConfirm}
      >
        <p>
          {context === "product_bundle" ? (
            <StaticIntlTranslator id="common:youNowHaveAccessToTheContent" />
          ) : (
            <StaticIntlTranslator id="common:youCanWatchRightNow" />
          )}
        </p>
      </SweetAlert>
    </>
  );
};

interface ItemsToStartEnrollmentProps {
  entity: EntityProps;
  context: string;
}

export default ItemsToStartEnrollment;
